<lib-form-field-container
    [kind]="FormContainerKind.None">

    <ng-content label select="[label]"></ng-content>
    <ng-content supportingText select="[supportingText]"></ng-content>
    <ng-container readOnly>
        <div #providedReadOnly class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">{{ formControl.value }}</div>
    </ng-container>

    <div class="sb-pill-select-group" [ngClass]="{'sb-pill-select-group-mobile': isMobile}">
        @for (item of itemQueryList; track item.value; let i = $index) {
            <lib-pill-select [ngClass]="{'sb-pill-select-mobile': isMobile}"
                [formControl]="viewControl.controls[i]"
                [value]="item.value"
                [isLoading]="isLoading"
                [qaTag]="item.qaTag"
                [disabled]="item.disabled"
                (change)="ChangeEvent()">
                <ng-container *ngTemplateOutlet="item.label"></ng-container>
            </lib-pill-select>
        }
    </div>
</lib-form-field-container>
